import { Field, Label, ErrorMessage } from "V2.0/common/fieldset";
import { Input } from "V2.0/common/input";
import { Switch, SwitchField } from "V2.0/common/switch";
import { Listbox, ListboxLabel, ListboxOption } from "V2.0/common/listbox";

export default WebhookForm;

const webhookEventTypeOptions = [
  { id: 1, value: "captureEvent", label: "Capture details from conversation" },
];

function WebhookForm(props) {
  const { formState, updateFormState, errors } = props;

  return (
    <div className="space-y-8">
      <Field>
        <Label>Name</Label>
        <Input
          type="text"
          value={formState.webhookName}
          invalid={!!errors.webhookName}
          onChange={(e) => updateFormState("webhookName", e.target.value)}
        />
      </Field>

      <Field>
        <Label>Event</Label>
        <Listbox
          as="div"
          className="my-4"
          value={formState.eventName}
          defaultValue={formState.eventName}
          onChange={(value) => updateFormState("eventName", value)}
        >
          {webhookEventTypeOptions.map((webhookEventTypeOption) => {
            return (
              <ListboxOption
                key={webhookEventTypeOption.id}
                value={webhookEventTypeOption.value}
              >
                <ListboxLabel>{webhookEventTypeOption.label}</ListboxLabel>
              </ListboxOption>
            );
          })}
        </Listbox>
      </Field>

      <Field>
        <Label>Webhook URL</Label>
        <Input
          type="text"
          value={formState.endpointUrl}
          onChange={(e) => updateFormState("endpointUrl", e.target.value)}
          invalid={!!errors.endpointUrl}
        />
        {errors.endpointUrl && (
          <ErrorMessage>{errors.endpointUrl}</ErrorMessage>
        )}
      </Field>

      <SwitchField>
        <Label>Auth Required</Label>
        <Switch
          color="emerald"
          checked={formState.authRequired}
          onChange={() => updateFormState("authRequired", !formState.authRequired)}
        />
      </SwitchField>

      {formState.authRequired && (
        <Field>
          <Label>Auth Key</Label>
          <Input
            type="text"
            value={formState.authKey}
            onChange={(e) => updateFormState("authKey", e.target.value)}
          />
        </Field>
      )}
    </div>
  );
}
